"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WithdrawalIcon = WithdrawalIcon;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _translations = require("../helpers/translations");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/*
*
* WithdrawalIcon Component
*
*/
function WithdrawalIcon(_ref) {
  var color = _ref.color,
      width = _ref.width;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 357 257",
    width: width || '28px'
  }, /*#__PURE__*/_react["default"].createElement("title", null, (0, _translations.getTranslations)('btn_withdrawal')), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: color || '#000'
    },
    d: "M212.7,232.84c6.46-10.8,12.56-20.91,18.56-31.09,1.55-2.63,3.07-1.07,4.58-.23a169.65,169.65,0,0,0,43.06,17.13c42.57,10.33,83,4.65,121.22-16.65,4.16-2.31,4.09-2.3,6.56,1.85,5.66,9.51,11.37,19,17.32,28.9-27.28,14.79-56.52,22.5-87.22,24.68C293.31,260.51,251.91,252.78,212.7,232.84Z",
    transform: "translate(-128 -195)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: color || '#000'
    },
    d: "M416.58,245.92c2.27,3.56,4.3,6.77,6.64,10.45-24.45,13.35-50.44,20.91-77.74,23.9-46.72,5.12-91.33-2.21-133.93-23.73,1.27-2.08,2.31-3.83,3.4-5.55s2.12-3.27,3.34-5.14a235.68,235.68,0,0,0,99.06,21.78C352,267.74,384.94,260.84,416.58,245.92Z",
    transform: "translate(-128 -180)"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    style: {
      fill: color || '#000'
    },
    d: "M276.94,386.64c16.06,3.19,32.69,7.07,49.51,9.65,12.87,2,25.73-.1,38.29-3.76,15.89-4.63,30.23-12.18,43.79-21.63s27.07-18.41,41.08-26.83c5.2-3.12,11.64-4.32,17.65-5.85,2.21-.56,4.95.07,7.22.84,9,3,12,10.1,6.51,17.8a116,116,0,0,1-17.37,19c-9.94,8.82-20.65,16.77-30.91,25.23-17.82,14.67-38.41,24.85-58.26,36.22-5.24,3-10.5,6-15.62,9.15-16.56,10.31-33.37,11.33-51.25,3-25.84-12-53-20.41-80.76-26.63-12.85-2.88-26.29-3.71-39.51-4.2-14.5-.53-29.05.37-43.58.7-5.69.12-7.71-.71-9.55-6.07a76.88,76.88,0,0,1-3.86-16.06,130.88,130.88,0,0,1,2.54-45.82,38.45,38.45,0,0,1,1.12-3.9c2.35-6.79,4.45-8.26,11.59-8.49,11.56-.37,23.26.12,34.65-1.48,12.34-1.75,24.49-5.16,36.58-8.4,18-4.83,35.55-4.16,52.71,3.13,13.69,5.82,27.83,7.22,42.61,6.3,15.59-1,31.27-1.14,46.89-.77A55.58,55.58,0,0,1,378.29,342c12.84,5.24,14.46,18.38,3.84,27.36-7.93,6.7-17.52,9.82-27.42,12.08-13.95,3.18-28,3.19-42.2,1.91C300.19,382.23,288.05,384.09,276.94,386.64Z",
    transform: "translate(-128 -200)"
  }));
}

WithdrawalIcon.propTypes = {
  color: _propTypes["default"].string,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
};
var _default = WithdrawalIcon;
exports["default"] = _default;